import React from 'react';
import { useNavigate } from 'react-router-dom';
import cn from 'classnames';
import './NavigationTabs.scss';

interface NavigationTabsProps {
    activeTab: 'products' | 'favorites' | 'account';
    onTabChange: (tab: 'products' | 'favorites' | 'account') => void;
}

export const NavigationTabs: React.FC<NavigationTabsProps> = ({
                                                                  activeTab,
                                                                  onTabChange
                                                              }) => {
    const navigate = useNavigate();

    const handleTabClick = (tab: 'products' | 'favorites' | 'account') => {
        onTabChange(tab);
        switch(tab) {
            case 'products':
                navigate('/');
                break;
            case 'favorites':
                navigate('/favorites');
                break;
            case 'account':
                navigate('/account');
                break;
        }
    };

    return (
        <div className="navigation-tabs">
            <button
                className={cn('navigation-tabs__item', {
                    'navigation-tabs__item--active': activeTab === 'products'
                })}
                onClick={() => handleTabClick('products')}
            >
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                    <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M19.842 8.299L13.842 3.632C12.759 2.789 11.242 2.789 10.158 3.632L4.158 8.299C3.427 8.867 3 9.741 3 10.667V18C3 19.657 4.343 21 6 21H18C19.657 21 21 19.657 21 18V10.667C21 9.741 20.573 8.867 19.842 8.299Z"
                        stroke={activeTab === 'products' ? "#00CCC6" : "#A5B2B2"}
                        strokeWidth="1.5"
                    />
                    <path
                        d="M16 14.238C13.79 16.448 10.208 16.448 8 14.238"
                        stroke={activeTab === 'products' ? "#00CCC6" : "#A5B2B2"}
                        strokeWidth="1.5"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />
                </svg>
                <span>Товары</span>
            </button>

            <button
                className={cn('navigation-tabs__item', {
                    'navigation-tabs__item--active': activeTab === 'favorites'
                })}
                onClick={() => handleTabClick('favorites')}
            >
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                    <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M15.7 4C18.87 4 21 6.98 21 9.76C21 15.39 12.16 20 12 20C11.84 20 3 15.39 3 9.76C3 6.98 5.13 4 8.3 4C10.12 4 11.31 4.91 12 5.71C12.69 4.91 13.88 4 15.7 4Z"
                        stroke={activeTab === 'favorites' ? "#00CCC6" : "#A5B2B2"}
                        strokeWidth="1.5"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />
                </svg>
                <span>Избранное</span>
            </button>

            <button
                className={cn('navigation-tabs__item', {
                    'navigation-tabs__item--active': activeTab === 'account'
                })}
                onClick={() => handleTabClick('account')}
            >
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                    <path
                        d="M18.3639 5.63604C21.8787 9.15076 21.8787 14.8492 18.3639 18.3639C14.8492 21.8787 9.15074 21.8787 5.63604 18.3639C2.12132 14.8492 2.12132 9.15074 5.63604 5.63604C9.15076 2.12132 14.8492 2.12132 18.3639 5.63604"
                        stroke={activeTab === 'account' ? "#00CCC6" : "#A5B2B2"}
                        strokeWidth="1.5"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />
                    <path
                        d="M13.9896 8.32391C15.0881 9.42245 15.0881 11.2035 13.9896 12.3021C12.891 13.4006 11.1099 13.4006 10.0114 12.3021C8.91287 11.2035 8.91287 9.42245 10.0114 8.32391C11.1099 7.22537 12.891 7.22537 13.9896 8.32391"
                        stroke={activeTab === 'account' ? "#00CCC6" : "#A5B2B2"}
                        strokeWidth="1.5"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />
                    <path
                        d="M17.707 18.958C16.272 17.447 14.248 16.5 12 16.5C9.75197 16.5 7.72797 17.447 6.29297 18.959"
                        stroke={activeTab === 'account' ? "#00CCC6" : "#A5B2B2"}
                        strokeWidth="1.5"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />
                </svg>
                <span>Аккаунт</span>
            </button>
        </div>
    );
};